var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXWerifyRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg824",
    width: 214.39999,
    height: 286.39999,
    viewBox: "0 0 214.39999 286.39999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs828"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1192"
  }, "\n      .cls-red-1 {\n        fill: #fff;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "g830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1200",
    transform: "translate(-85.021223,25.678042)",
    style: {
      fill: "#ff0000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1369",
    transform: "translate(60)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-red-1",
    points: "96.26,94.47 136.6,162.66 262.21,0 281.62,0 136.09,231.32 53.87,94.47 ",
    id: "polygon1196",
    style: {
      fill: "#c60042",
      fillOpacity: 1,
      strokeWidth: 1.42296
    },
    transform: "matrix(0.70276263,0,0,0.70276263,39.34654,-17.582572)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-red-1",
    points: "281.62,0 136.09,231.32 53.87,94.47 96.26,94.47 136.6,162.66 262.21,0 ",
    id: "polygon1196-3",
    style: {
      fill: "#c60042",
      fillOpacity: 1,
      strokeWidth: 1.42296
    },
    transform: "matrix(-0.70276263,0,0,-0.70276263,228.98288,259.29185)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWerifyRed);
export default __webpack_public_path__ + "static/media/x_werify_red.1a1c441c69c3a7142428b9f33d53b703.svg";
export { ForwardRef as ReactComponent };